<div class="container">
  <data-table
    [columns]="columnasAreas"
    [configuration]="configurationAreas"
    [reloadTable]="recargarTablaAreas"
    (add)="agregarAreas($event)"
    (edit)="editarAreas($event)"
    (delete)="eliminarAreas($event)"
    [params]="params"
    [url]="urlGetDatosAreas"
    (selection)="seleccionadosAreas($event)"
    (clickRow)="clickFilaAreas($event)"
  ></data-table>
</div>
